import React from 'react'
import leftFlower from '../../Assests/Team/leftFlower.svg';
import rightFlower from '../../Assests/Team/rightFlower.svg';
import mitDelta from '../../Assests/Team/mitDeltav.svg';
import mitImage from '../../Assests/Team/mitImage.svg';
import sandbox from '../../Assests/Team/sandbox.svg';
import legatum from '../../Assests/Team/legatum.svg';
import '../../Styles/Teams.scss'
import AiGen from '../../Assests/Team/aiGenSumit.svg';
import nascomAi from '../../Assests/Team/nascomAi.svg';
import mitMediaLab from '../../Assests/Team/mitMediaLab.svg';

function OurtrustedPartner() {
    return (
        <>
            {/* <div className='px-5 py-3'>

                <div className=' fw-bold overall-text-color our-trusted-text'>
                    Our Trusted Partners
                </div>
            </div> */}
            {/* <div className='row images-alignment mt-5 pt-2 w-100 text-center '>

                <div className='col-md-6 '>
                    <div >
                        <img className='our-trusted-images' src={intel} alt="Intel" />
                    </div>
                    <div className='our-Trusted mt-2 pt-5'>
                        Infrastructure
                    </div>
                    <div className='d-flex justify-content-center our-Trusted-sub'>
                        <div className='w-50 mt-2'>
                            Our infrastructure partners provide secure, scalable tech, enabling us to deliver proactive healthcare solutions.
                        </div>
                    </div>
                </div>
                <div className='col-md-6'>
                    <div>
                        <img className='our-trusted-images' src={kimsImage} alt="MGI" />
                    </div>
                    <div className='our-Trusted mt-2 pt-5'>
                        Business
                    </div>
                    <div className='d-flex justify-content-center our-Trusted-sub'>
                        <div className='w-50 mt-2'>
                            Business partners extend our reach, bringing industry expertise to support impactful healthcare solutions.
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <div className='row images-alignment  w-100 text-center mt-5'>

                <div className='col-md-6'>
                    <div>
                        <img className='our-trusted-images' src={mgiImage} alt="Intel" />
                    </div>
                    <div className='our-Trusted mt-2 pt-5'>
                        Research Labs
                    </div>
                    <div className='d-flex justify-content-center our-Trusted-sub'>
                        <div className='w-50 mt-2'>
                            With leading research labs, we drive innovation through data-backed insights and pioneering health studies.
                        </div>
                    </div>
                </div>
                <div className='col-md-6 '>
                    <div>
                        <img className='our-trusted-images' src={upmcImage} alt="MGI" />
                    </div>
                    <div className='our-Trusted mt-2 pt-5'>
                        Universities
                    </div>
                    <div className='d-flex justify-content-center our-Trusted-sub'>
                        <div className='w-50 mt-2'>
                            University partnerships turn academic research into practical advancements in healthcare.
                        </div>
                    </div>
                </div>
            </div> */}


            <div className="team-discover-story-above mt-5">
                <div className="mt-5">
                    <div className="text-center achievement-text mt-5 overall-text-color" style={{ fontSize: '36px', fontWeight: '700' }}>
                        Achievements & Awards
                    </div>
                    <div className="achievements-container images-alignment mt-5 text-center ">
                        <div className="achievement-flower">
                            <img src={leftFlower} alt="left" />
                        </div>

                        <div className="achievement-large">
                            <div className="mt-3">
                                <img src={legatum} alt="legatum" />
                            </div>
                            <div className="mt-3 achievement-description ">
                                Selected in MIT Legatum Fellowship award in 2021
                            </div>
                        </div>

                        <div className="achievement-medium">
                            <div>
                                <img className='mob-sandox' src={sandbox} alt="sandbox" />
                            </div>
                            <div className="mt-1 w-100 achievement-description">
                                Sandbox Innovation team award 2022
                            </div>
                        </div>

                        <div className="achievement-medium">
                            <div className="mt-1">
                                <img src={mitImage} alt="mit" />
                            </div>
                            <div className="mt-4 w-100 achievement-description">
                                First prize winner at MIT 100K Accelerator 2022
                            </div>
                        </div>

                        <div className="achievement-large">
                            <div>
                                <img src={mitDelta} alt="mit delta" />
                            </div>
                            <div className="mt-2 achievement-description">
                                Selected in MIT Deltav Accelerator Program 2022
                            </div>
                        </div>

                        <div className="achievement-flower">
                            <img src={rightFlower} alt="right" />
                        </div>
                    </div>

                    <div className="achievements-container images-alignment d-flex justify-content-center mt-0  mt-md-4">
                        <div className="achievement-medium mt-3">
                            <div className="text-center mt-3">
                                <img className='mob-mit' src={mitMediaLab} alt="mit media lab" />
                            </div>
                            <div className="achievement-description mt-4 " >
                             First prize winner at AI for impact MIT Media lab pitch 2022
                            </div>
                        </div>

                        <div className="achievement-medium">
                            <div className="text-center">
                                <img src={nascomAi} alt="nascom AI" />
                            </div>
                            <div className="achievement-description ms-5 mt-3">
                                Winner of Nasscom Gamechangers 2023-24
                            </div>
                        </div>

                        <div className="achievement-medium last-our-img">
                            <div className="text-center">
                                <img src={AiGen} alt="AiGen" />
                            </div>
                            <div className="achievement-description mt-3">
                             BW GenAI Leadership GenAI Founder of the Year Award
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default OurtrustedPartner